import { getArticles } from '@/graphql/queries/media/article';
import { getGuides } from '@/graphql/queries/media/guide';
import { getPressclippings } from '@/graphql/queries/media/pressclipping';
import lang from '@/lang/middleware/media';

export default async ({ $apolloQuery, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('newsroom.description');
  const jumboTitle = store.$i18n.t('newsroom.jumbotron.title');
  const subtitle = store.$i18n.t('newsroom.jumbotron.subtitle');
  const title = store.$i18n.t('podcasts.jumbotron.title');
  store.commit('jumbotron/SET_JUMBOTRON', { extra: 'site-blog-newsletter-signup', subtitle, title: jumboTitle, type: 'generic' });
  store.commit('pageContent/setHead', { description, title });

  await $apolloQuery(getArticles, { per: 4 }).then(result => store.commit('blog/setList', result.articles));
  await $apolloQuery(getGuides).then(result => store.commit('blog/setGuides', result.guides));
  await $apolloQuery(getPressclippings, { page: 1 }).then(result => store.commit('blog/setMedia', result.clippings));
  await $apolloQuery(getPressclippings, { type: 'podcasts', page: 1 }).then(result => store.commit('blog/setPodcasts', result.clippings));
};
